import PageBlock from '@/components/PageBlock';

import styles from './partnership-how-to.module.css';

const PartnershipHowTo = ({ title, items }) => {
  return (
    <PageBlock
      className={styles.root}
      title={title}
      variant="white"
    >
      <div className={styles.list}>
        {items.map(({ name, description, image }, index) => (
          <div className={styles.item} key={name}>
            <div className={styles.content}>
              <div className={styles.name}>
                {index + 1}. {name}
              </div>
              <div className={styles.description}>
                {description}
              </div>
            </div>
            <img className={styles.image} src={image} alt={name} />
          </div>
        ))}
      </div>
    </PageBlock>
  );
};

export default PartnershipHowTo;
